export const usage = `
<h4>Usage:</h4>
<p>
This sample contains several views of the area including Surface Changes, Radar Imagery, Digital Surface Models (DSM), and Shaded Reliefs.
</p>
<p>
The data is presented in geographic coordinates at a resolution of approximately 14m and can be:
<ul>
<li>Toggled on and off by accessing the layers</li>
<li>Adjusted to be transparent</li>
<li>Scaled</li>
<li>Colormaped to highlight different values</li>
</ul>
</p>
`
